const observer = new MutationObserver(() => {
  // Klaviyo logo img alt/role fix
  document.querySelectorAll('img[class*="kl-private-reset-css"]:not([alt])').forEach(img => {
    img.setAttribute('alt', 'Instafire Logo');
    img.setAttribute('role', 'presentation');
  });

  // Pandectes consent banner links: announce new tab
  document.querySelectorAll('a.cc-link[target="_blank"]:not([aria-label])').forEach(a => {
    const txt = (a.textContent || '').trim() || 'Link';
    a.setAttribute('aria-label', `${txt} (opens in a new tab)`);
  });
});

observer.observe(document.body, { childList: true, subtree: true });